import React from 'react';

const TeacherManagement = ({ teachers, onTeacherSelect }) => {
  const getSubjectColor = (subject) => {
    const colors = {
      '中文': 'bg-red-100 text-red-800',
      '英文': 'bg-blue-100 text-blue-800',
      '數學': 'bg-green-100 text-green-800',
      '物理': 'bg-purple-100 text-purple-800',
      '化學': 'bg-yellow-100 text-yellow-800',
      '生物': 'bg-pink-100 text-pink-800',
      '歷史': 'bg-indigo-100 text-indigo-800',
      '地理': 'bg-teal-100 text-teal-800',
      '經濟': 'bg-orange-100 text-orange-800',
      '通識教育': 'bg-gray-100 text-gray-800',
      '體育': 'bg-emerald-100 text-emerald-800',
      '音樂': 'bg-rose-100 text-rose-800',
      '視覺藝術': 'bg-violet-100 text-violet-800'
    };
    return colors[subject] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="teacher-management">
      <div className="section-header">
        <h2>教師管理</h2>
        <p>管理教師資料和任教科目</p>
      </div>

      <div className="teachers-grid">
        {teachers.map((teacher) => (
          <div 
            key={teacher.id} 
            className="teacher-card"
            onClick={() => onTeacherSelect(teacher)}
          >
            <div className="teacher-card-header">
              <div className="teacher-avatar">
                <span className="avatar-text">
                  {teacher.teacher_name.charAt(0)}
                </span>
              </div>
              <div className="teacher-info">
                <h3 className="teacher-name">{teacher.teacher_name}</h3>
                <p className="teacher-id">教師編號: {teacher.teacher_id}</p>
              </div>
            </div>

            <div className="teacher-details">
              <div className="detail-item">
                <span className="detail-label">任教科目:</span>
                <div className="subjects-list">
                  {teacher.subjects && teacher.subjects.map((subject, index) => (
                    <span 
                      key={index} 
                      className={`subject-tag ${getSubjectColor(subject)}`}
                    >
                      {subject}
                    </span>
                  ))}
                </div>
              </div>
              
              <div className="detail-item">
                <span className="detail-label">聯絡方式:</span>
                <div className="contact-info">
                  <p className="contact-item">📧 {teacher.email}</p>
                  <p className="contact-item">📞 {teacher.phone}</p>
                </div>
              </div>
            </div>

            <div className="teacher-actions">
              <button className="action-btn primary">
                📅 查看時間表
              </button>
            </div>
          </div>
        ))}
      </div>

      {teachers.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">👨‍🏫</div>
          <h3>暫無教師資料</h3>
          <p>請檢查資料庫連接或聯繫系統管理員</p>
        </div>
      )}
    </div>
  );
};

export default TeacherManagement;
